import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getVendorPOQuery = async (id) => {
    if (id) {
        const response = await axios.get(`${apiurl?.getVendorPO}?purchaseOrderId=${id}`);
        return response;
    }
    return null;
};

const getVendorPO = (id) => {
    return useQuery(['getVendorPO'],
        () => getVendorPOQuery(id), { refetchOnWindowFocus: false });
};

export { getVendorPO, getVendorPOQuery };
